import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import MenuPresu from "./menu";
import { Toasts } from "../toasts";
import TablaEjFiscal from "./tablaEfiscal";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import Menu from "../comun/Menu/Menu";
import CargarCatdesdeEfiscal from "./modalCargarCatdesdeEfiscal";
import CargarPucEfiscal from "./modalCargarPucdesdeEfiscal";
import TablaCatgProgramaticas from "./tablaCategoriasProgramaticas";
import TablaClasificadorPresupuestario from "./tablaClasificadorPresupuestario";
import TablaPresupuesto from "./tablapresupuesto";
import TablaCuadroObra from "./tablaCuadrodeObras";
import TablaPartidasExtras from "./tablaPartidasExtras";
import TablaAumentados from "./tablaAumentados";
import TablaDisminucion from "./tablaDisminucion";
import TablaTraslados from "./tablaTraslados";
import TablaCompromisos from "./tablaCompromiso";
import TablaModificarCompromisos from "./tablaModificarCompromiso";
import TablaAjustarCompromisos from "./tablaAjustarCompromiso";
import { ImprimirDozavo } from "./modalImprimeDozavo";
import { ImprimirEstadoFinancieroPresupuesto } from "./modalImprimeEstadofinanciero";
import { ImprimirEjecucionTrimestralIngresos } from "./modalImprimeEjecucionTrimestral";
import { ImprimirEJCGR } from "./modalImprimeEJCGR";
import { ImprimirMIJMFBCV } from "./modalImprimeMIJMFBCV";
import { ImprimirRelacionObrasProyectos } from "./modalImprimeRelacionObrasPresupuestadas";
import { ImprimirDisponibilidadporPartidas } from "./modalImprimeDisponibilidadpPartidas";
import { ImprimirEjecucionMensualPartidasdCuentas } from "./modalImprimeEjecucionMensualPartidasCuentas";
import { ImprimirEjGastoPartCuentSubCat } from "./modalImprimeEJGastoPartCuentSubCat";
import { ImprimirEjGastoPartCuents } from "./modalImprimeEJGastoPartCuents";
import { ImprimirPartidasSubCreaReduV } from "./modalImprimeAPRESUBCREA";
import { ImprimirCompOrdServc } from "./modalImprimeCompOrdServ";
import { ImprimirTrasladoListaCompromisoProveedor } from "./modalImprimeTrasladoListaCompProveedor";
import { ImprimirListaXOrdenCompra } from "./modalImprimeListaXOrdenCompra";
import ValidarUsuario from "../comun/modalValidarUsuario";
import TablaCreditoAdicional from "./tablaCreditoAdicional";
import TablaAprobarCompromisos from "./tablaAprobarCompromiso";
import TablaAprobarImputacion from "./tablaAprobarImputacion";
import TablaDesaprobarSolicitudCompras from "./tablaDesaprobarSolicitudCompras";
import TablaDesaprobarSolicitudObras from "./tablaDesaprobarSolicitudObras";
import TablaDesaprobarSolicitudDonacion from "./tablaDesaprobarSolicitudDonacion";
import CambiarEfiscal from "../configuracionGeneral/modalCambiarEfiscal";
import TablaUsuarioPresu from "./tablaUsuarioPresu";
import { CambiarClaveSupervisor } from "../comun/modalCambiarClaveSupervisor";
import Item from "../comun/Menu/Item";
import imgPresupuesto from "../../imagenes/fd_presupuesto.png";
import Footer from "../Footer";

function MenuPresupuesto(props) {
  const login = JSON.parse(localStorage.getItem("post")).login
  const accefiscal = JSON.parse(localStorage.getItem("accefiscal"));
  const acccatpro = JSON.parse(localStorage.getItem("acccatpro"));
  const accpuc = JSON.parse(localStorage.getItem("accpuc"));
  const accformpresu = JSON.parse(localStorage.getItem("accformpresu"));
  const accaprobpresup = JSON.parse(localStorage.getItem("accaprobpresup"));
  const accaprocompro = JSON.parse(localStorage.getItem("accaprocompro"));
  const accpartext = JSON.parse(localStorage.getItem("accpartext"));
  const accaumentopart = JSON.parse(localStorage.getItem("accaumentopart"));
  const accdisminucionpart = JSON.parse(
    localStorage.getItem("accdisminucionpart"),
  );
  const acctraslado = JSON.parse(localStorage.getItem("acctraslado"));
  const acccompromiso = JSON.parse(localStorage.getItem("acccompromiso"));
  const accreppuc = JSON.parse(localStorage.getItem("accreppuc"));
  const accrepformpresu = JSON.parse(localStorage.getItem("accrepformpresu"));
  const acccambioefiscal = JSON.parse(localStorage.getItem("acccambioefiscal"));
  const accreppresuing = JSON.parse(localStorage.getItem("accreppresuing"));
  const accrepedofinanc = JSON.parse(localStorage.getItem("accrepedofinanc"));
  const accrepcondicpar = JSON.parse(localStorage.getItem("accrepcondicpar"));
  const accrepmovpresu = JSON.parse(localStorage.getItem("accrepmovpresu"));
  const accrepcomprom = JSON.parse(localStorage.getItem("accrepcomprom"));
  const superpresu = JSON.parse(localStorage.getItem("superpresu"));
  const accusuariopresu = JSON.parse(localStorage.getItem('accusuariopresu')) === null ? "0000" : JSON.parse(localStorage.getItem('accusuariopresu')).trim();

  const { user, logout } = useContext(AuthContext);
  const pathname = window.location.pathname;
  const statuspresup = JSON.parse(localStorage.getItem("statuspresup"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idorganizacion = JSON.parse(localStorage.getItem("idorganizacion"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const efiscalanio = JSON.parse(localStorage.getItem("efiscalanio"));
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const path = pathname === "/" ? "login" : pathname.substr(1);
  const [operacion, setOperacion] = useState(0);
  const [ubi, setUbi] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [tipocom, setTipocom] = useState(null);
  const [valorcp, setValorcp] = useState(0);
  const [devuelto, setDevuelto] = useState(null);
  const [operacionpu, setOperacionpu] = useState(0);
  const [operacioncat, setOperacioncat] = useState(0);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo1, setTitulo1] = useState("");
  const [titulo2, setTitulo2] = useState("");
  const [titulo3, setTitulo3] = useState("");
  const [show, setShow] = useState(false);

  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [activate, setActivate] = useState(false);
  const [titulo, setTitulo] = useState();
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [vtitulo, setVtitulo] = useState("");
  const [vtitulo1, setVtitulo1] = useState("");
  const [vtitulo2, setVtitulo2] = useState("");
  const [vtitulo3, setVtitulo3] = useState("");

  const [titulo4, setTitulo4] = useState("");

  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );

  const [tabla, setTabla] = useState(0);

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  let el;
  function menuclick() {
    if ((el = document.getElementById("wrapper"))) {
      el.classList.toggle("toggled");
    }
  }

  let ele;
  const bloquear = (titulo) => (e) => {
    e.preventDefault();
    /* setTitulo1(titulo); */
    if ((el = document.getElementById("wrapper"))) {
      el.classList.toggle("toggled");
      if ((ele = document.getElementById("menu-toggle"))) {
        ele.classList.toggle("bloquear");
      }
    }
  };

  const SeleccionarEfiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var idefiscal = response.data[0].idefiscal;
          var descriptor = response.data[0].descriptor;
          var anio = response.data[0].anio;
          var observaciones = response.data[0].observaciones;
          var statusorg = response.data[0].statusorg;
          var statuspresup = response.data[0].statuspresup;
          var statuspuc = response.data[0].statuspuc;
          var statuscat = response.data[0].statuscat;
          var idorganizacion = response.data[0].idorganizacion;

          localStorage.setItem("idefiscal", idefiscal);
          localStorage.setItem("efiscaldes", descriptor);
          localStorage.setItem("efiscalanio", anio);
          localStorage.setItem("efiseleccionado", true);
          localStorage.setItem("statuspresup", statuspresup);
          localStorage.setItem("statuspuc", statuspuc);
          localStorage.setItem("statuscat", statuscat);
          localStorage.setItem("statusorg", statusorg);
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const itemClick = (op, ubi, tipo, tipocom) => (e) => {
    menuclick();
    if (op === 0) {
      setTabla(0);
    } else if (op === 1) {
      setTabla(1);
    } else if (op === 2) {
      setTabla(2);
    } else if (op === 3) {
      setTabla(3);
    } else if (op === 4) {
      setTabla(4);
    } else if (op === 5) {
      setTabla(5);
    } else if (op === 6) {
      if (accpartext.toString() === "1") {
        setTabla(6);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      }
    } else if (op === 7) {
      if (accaumentopart.toString() === "1") {
        setTabla(7);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      }
    } else if (op === 8) {
      if (accdisminucionpart.toString() === "1") {
        setTabla(8);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      }
    } else if (op === 9) {
      if (acctraslado.toString() === "1") {
        setTabla(9);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      }
    } else if (op === 10) {
      if (acccompromiso.toString() === "1") {
        setTabla(10);
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      }
    } else if (op === 11) {
      setTabla(11);
    } else if (op === 12) {
      setTabla(12);
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/eliminarcatprogramatica/${operacioncat}`;
    let body;
    setActivate(true);

    body = {
      idefiscal: idefiscal,
      val: valorcp,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let mensa = "";
          if (operacioncat === 6) {
            mensa = "Categoria Programática Eliminada Correctamente";
          } else if (operacioncat === 7) {
            mensa = "Clasificador Presupuestario Eliminado Correctamente";
          } else if (operacioncat === 8) {
            mensa = "Presupuesto Eliminado Correctamente";
          }
          //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registros Eliminado Correctamente', icono: 'exito' });
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensa,
            icono: "exito",
          });
          SeleccionarEfiscal();
        }

        setActivate(false);
        setTabla(0);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setTabla(0);
      });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
    /* if (operacioncat === 6) {
            setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
            Actualizar();
        } else if (operacioncat === 7) {
            setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
            Actualizar();
        } */
  };

  const SelecccionarEfiscal = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    console.log("entro");

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.statuscat !== 32) {
            setMostrar3(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La Categoria Programática ya fué Cargada",
              icono: "informacion",
            });
            setTabla(0);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelecccionarEfiscals = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.statuspuc !== 22) {
            setMostrar4(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Los Clasificadores Presupuestarios ya Fuerón Cargados",
              icono: "informacion",
            });
            setTabla(0);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const modalCargCat = () => {
    setMostrar3(false);
    setTabla(0);
  };

  const modalCargPuc = () => {
    setMostrar4(false);
    setTabla(0);
  };

  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    setTabla(16);
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const actualizacionItem = {
    title: "Presupuesto",
    icon: "fas fa-pen-alt me-2",
    drop: [
      {
        title: "Ejercicio Fiscal",
        itemClickValue: 1,
        subDrop: null,
        icon: "fas fa-tags fa-fw me-1",
      },
      {
        title: "Categorias Programaticas »",
        itemClickValue: null,
        permission: acccatpro.trim() === '1' ? true : false,
        subDrop: [
          {
            title: "Cargar desde Ejercicio Fiscal",
            itemClickValue: 40,
            subDrop: null,
            icon: "fas fa-exchange-alt fa-fw me-1",
          },
          {
            title: "Actualizar",
            itemClickValue: 2,
            subDrop: null,
            icon: "fas fa-exchange-alt fa-fw me-1",
          },
          {
            title: "Eliminar Categorias Programaticas",
            itemClickValue: 41,
            subDrop: null,
            icon: "fa fa-trash fa-fw me-1",
          },
        ],
        icon: "far fa-copy fa-fw me-1",
      },
      {
        title: "Clasificador Presupuestario »",
        itemClickValue: null,
        permission: accpuc.trim() === '1' ? true : false,
        subDrop: [
          {
            title: "Cargar desde Ejercicio Fiscal",
            itemClickValue: 42,
            subDrop: null,
            icon: "fas fa-exchange-alt fa-fw me-1",
          },
          {
            title: "Actualizar",
            itemClickValue: 3,
            subDrop: null,
            icon: "fas fa-exchange-alt fa-fw me-1",
          },
          {
            title: "Eliminar Clasificador Presupuestario",
            itemClickValue: 43,
            subDrop: null,
            icon: "fa fa-trash fa-fw me-1",
          },
        ],
        icon: "fas fa-cog fa-fw me-1",
      },
      {
        title: "Formular Presupuesto »",
        itemClickValue: 1,
        permission: accformpresu.trim() === '1' ? true : false,
        subDrop: [
          /*{
                        title: 'Cargar Presupuesto »',
                        itemClickValue: null,
                        subDrop: [
                            {
                                title: 'Cargar desde Otros',
                                itemClickValue: null,
                                subDrop: null,
                                icon: 'fas fa-exchange-alt fa-fw me-1'
                            },
                            {
                                title: 'Cargar por Promedios',
                                itemClickValue: null,
                                subDrop: null,
                                icon: 'fas fa-sort-numeric-down-alt fa-fw me-1'
                            },

                        ],
                        icon: 'fas fa-share fa-fw me-1'
                    },*/
          {
            title: "Crear Presupuesto",
            itemClickValue: 4,
            subDrop: null,
            icon: "fas fa-plus-square fa-fw me-1",
          },
          {
            title: "Cuadro de Obras",
            itemClickValue: 5,
            subDrop: null,
            icon: "fa fa-trash fa-fw me-1",
          },
          {
            title: "Eliminar Presupuesto",
            itemClickValue: 21,
            subDrop: null,
            icon: "fa fa-trash fa-fw me-1",
          },
        ],
        icon: "fas fa-external-link-alt fa-fw me-1",
      },
      {
        title: "Ejecución Presupuestaria »",
        itemClickValue: null,
        subDrop: [
          {
            title: "Partidas Extras Aprobadas",
            itemClickValue: 6,
            permission: accpartext.trim() === '1' ? true : false,
            subDrop: null,
            icon: "fas fa-check-square fa-fw me-1",
          },
          {
            title: "Aumentos de Partidas",
            itemClickValue: 7,
            permission: accaumentopart.trim() === '1' ? true : false,
            subDrop: null,
            icon: "fas fa-chart-line fa-fw me-1",
          },
          {
            title: "Reducción de Partidas",
            itemClickValue: 8,
            permission: accdisminucionpart.trim() === '1' ? true : false,
            subDrop: null,
            icon: "fas fa-arrow-down fa-fw me-1",
          },
          {
            title: "Traslados de Partidas",
            itemClickValue: 9,
            permission: acctraslado.trim() === '1' ? true : false,
            subDrop: null,
            icon: "fas fa-exchange-alt fa-fw me-1",
          },
          {
            title: "Compromisos",
            itemClickValue: 10,
            permission: acccompromiso.trim() === '1' ? true : false,
            subDrop: null,
            icon: "fab fa-pied-piper-square fa-fw me-1",
          },
          {
            title: "Ajustar Compromisos",
            itemClickValue: 11,
            permission: acccompromiso.trim() === '1' ? true : false,
            subDrop: null,
            icon: "fas fa-share fa-fw me-1",
          },
          {
            title: "Aprobaciones »",
            itemClickValue: null,
            permission: accaprocompro.trim() === '1' ? true : false,
            subDrop: [
              {
                title: "Aprobar Compromiso",
                itemClickValue: 13,
                subDrop: null,
                icon: "fas fa-check-double fa-fw me-1",
              },
              {
                title: "Desaprobar Solicitud de Compra",
                itemClickValue: 15,
                subDrop: null,
                icon: "fas fa-file-excel fa-fw me-1",
              },
              {
                title: "Desaprobar Solicitud de Pago de Obras",
                itemClickValue: 17,
                subDrop: null,
                icon: "fas fa-file-excel fa-fw me-1",
              },
              {
                title: "Aprobar Imputación O.C",
                itemClickValue: 14,
                subDrop: null,
                icon: "fas fa-check-double fa-fw me-1",
              },
              {
                title: "Desaprobar Solicitud de Donación",
                itemClickValue: 18,
                subDrop: null,
                icon: "fas fa-file-excel fa-fw me-1",
              },
            ],
            icon: "fas fa-clipboard-check fa-fw me-1",
          },
          {
            title: "Credito Adicional",
            itemClickValue: 12,
            permission: accaumentopart.trim() === '1' ? true : false,
            subDrop: null,
            icon: "fas fa-coins fa-fw me-1",
          },
          {
            title: "Modificar Compromisos",
            itemClickValue: 44,
            subDrop: null,
            icon: "fas fa-retweet fa-fw me-1",
          },
        ],
        icon: "fas fa-calculator fa-fw me-1",
      },
      {
        title: "Cambio Año Presupuesto",
        itemClickValue: 37,
        permission: acccambioefiscal.trim() === '1' ? true : false,
        subDrop: null,
        icon: "fas fa-calendar-alt fa-fw me-1",
      },
    ],
  };
  const imprimirItem = {
    title: "Reportes",
    icon: "fa fa-print me-2",
    drop: [
      {
        title: "Clasificador Presupuestario",
        itemClickValue: 45,
        permission: accreppuc.trim() === '1' ? true : false,
        icon: "fas fa-poll-h fa-fw me-1",
      },
      {
        title: "Formulación Presupuestaria »",
        itemClickValue: null,
        permission: accrepformpresu.trim() === '1' ? true : false,
        icon: "fas fa-angle-double-right fa-fw me-1",
        subDrop: [
          {
            title: "Presupuesto de Ingresos",
            itemClickValue: 46,
            icon: "fas fa-angle-double-right fa-fw me-1",
          },
          {
            title: "Indices de Categorias Programaticas",
            itemClickValue: 47,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Clasificación por Objeto de Gastos",
            itemClickValue: 48,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Solicitud de Recursos",
            itemClickValue: 49,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Solicitud de Recursos(Ordinal)",
            itemClickValue: 50,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Resumen de Gastos »",
            itemClickValue: null,
            icon: "fas fa-angle-double-right fa-fw me-1",
            subDrop: [
              {
                title: "A Nivel de Sectores",
                itemClickValue: 51,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "A Nivel de Programas",
                itemClickValue: 52,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "A Nivel de Sub-Programas",
                itemClickValue: 53,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "A Nivel de Proyecto",
                itemClickValue: 54,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "A Nivel de Actividad",
                itemClickValue: 55,
                icon: "fas fa-poll-h fa-fw me-1",
              },
            ],
          },
          {
            title: "Gasto de Inversión Estimado(Obras)",
            itemClickValue: 56,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Relación de Cargos",
            itemClickValue: 57,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Relación de Cargos por Tipo",
            itemClickValue: 58,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Relación de Transferencia",
            itemClickValue: 59,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Gasto de Inversión Estimados",
            itemClickValue: 60,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Costo de Equipos",
            itemClickValue: 61,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Resumen de Crédito Presupuestado",
            itemClickValue: 62,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },
      {
        title: "Formulación Presupuestaria Publicación 21 »",
        itemClickValue: null,
        permission: accrepformpresu.trim() === '1' ? true : false,
        icon: "fas fa-poll-h fa-fw me-1",
        subDrop: [
          {
            title: "Información General del Municipio(F2100)",
            itemClickValue: 63,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title:
              "Recursos Humanos/Talento Humano por Tipo de Cargo y Genero(F2107)",
            itemClickValue: 64,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Descripción del Programa y Sub-Programa(F2111)",
            itemClickValue: 65,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Metas del Programa, Sub-Programa y/o Proyecto(F2112)",
            itemClickValue: 66,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Personal Jubilado y Pensionado Nivel Categoria(F2114)",
            itemClickValue: 67,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Presupuesto de Ingresos(F2102)",
            itemClickValue: 68,
            icon: "fas fa-poll-h fa-fw me-1",
          },

          {
            title: "Indice de Categorias Programaticas(F2103)",
            itemClickValue: 69,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title:
              "Resumen de los Créditos Presupuestarios a Nivel de Sectores y Partidas(F2106)",
            itemClickValue: 70,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title:
              "Presupuesto de Gastos por Sectores a Nivel de Partidas y Sub-Partidas(F2119)",
            itemClickValue: 71,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title:
              "Presupuesto de Gasto General a Nivel de Partidas Especifica",
            itemClickValue: 72,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },
      {
        title: "Solicitud de Dozavo",
        itemClickValue: 23,
        icon: "fas fa-poll-h fa-fw me-1",
      },
      {
        title: "Presupuesto de Ingreso",
        itemClickValue: 24,
        permission: accreppresuing.trim() === '1' ? true : false,
        icon: "fas fa-poll-h fa-fw me-1",
      },
      {
        title: "Ejecución Trimestral Presupuesto Ingreso",
        itemClickValue: 25,
        permission: accreppresuing.trim() === '1' ? true : false,
        icon: "fas fa-poll-h fa-fw me-1",
      },

      {
        title: "Ejecución Presupuestaria »",
        itemClickValue: null,
        icon: "fas fa-poll-h fa-fw me-1",
        subDrop: [
          {
            title: "EJ_DPP01",
            itemClickValue: 73,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "EJ_DPP02",
            itemClickValue: 74,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "EJ_DPP03",
            itemClickValue: 75,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "EJ_DPP04",
            itemClickValue: 76,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "EJ_DPP05",
            itemClickValue: 77,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "EJ_DPP06",
            itemClickValue: 78,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "MIJ_01",
            itemClickValue: 79,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "MIJ_02",
            itemClickValue: 80,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "MF_00",
            itemClickValue: 81,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "BCV_F3",
            itemClickValue: 82,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "BCV_F6",
            itemClickValue: 83,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "CGR_01",
            itemClickValue: 84,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "CGR_02",
            itemClickValue: 85,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },

      {
        title: "Estados Financieros »",
        itemClickValue: null,
        permission: accrepedofinanc.trim() === '1' ? true : false,
        icon: "fas fa-angle-double-right fa-fw me-1",
        subDrop: [
          {
            title: "Unidad Ejecutora",
            itemClickValue: 86,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Relación de Obras",
            itemClickValue: 87,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Resumen General de Proyectos",
            itemClickValue: 88,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Disponibilidad Presupuestaria por Partidas",
            itemClickValue: 29,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },

      {
        title: "Estado Financiero Mensual de Gasto »",
        itemClickValue: null,
        permission: accrepcondicpar.trim() === '1' ? true : false,
        icon: "fas fa-angle-double-right fa-fw me-1",
        subDrop: [
          {
            title: "Nivel Partidas de Cuentas",
            itemClickValue: 89,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Nivel SubEspecificas/Cat.Programatica",
            itemClickValue: 31,
            icon: "fas fa-poll-h fa-fw me-1",
          },

          {
            title: "Nivel Categorias Programaticas »",
            itemClickValue: null,
            icon: "fas fa-poll-h fa-fw me-1",
            subDrop: [
              {
                title: "Sectores",
                itemClickValue: 90,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "Programas",
                itemClickValue: 91,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "Sub-Programas",
                itemClickValue: 92,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "Proyectos",
                itemClickValue: 93,
                icon: "fas fa-poll-h fa-fw me-1",
              },
              {
                title: "Actividad",
                itemClickValue: 94,
                icon: "fas fa-poll-h fa-fw me-1",
              },
            ],
          },
          {
            title: "Disponibilidad del Periodo General",
            itemClickValue: 95,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Analitico por Partidas",
            itemClickValue: 96,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Resumen General de Obras",
            itemClickValue: 116,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Ejecución del Gasto por Partidas",
            itemClickValue: 97,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Ejecución del Gasto por Cuentas",
            itemClickValue: 98,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },
      {
        title: "Movimientos del Presupuesto »",
        itemClickValue: null,
        permission: accrepmovpresu.trim() === '1' ? true : false,
        icon: "fas fa-angle-double-right fa-fw me-1",
        subDrop: [
          {
            title: "Aumento y/o Crédito Adicional",
            itemClickValue: 99,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Reducción",
            itemClickValue: 100,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Traslado",
            itemClickValue: 101,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Nivel de Partidas",
            itemClickValue: 102,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Nivel de SubEspecificas",
            itemClickValue: 103,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Nivel de SubEspecificas por Sector",
            itemClickValue: 104,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Partidas Creadas a Posteriori",
            itemClickValue: 105,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },
      {
        title: "Compromisos(Ord.Compra/Servicio) »",
        itemClickValue: null,
        permission: accrepcomprom.trim() === '1' ? true : false,
        icon: "fas fa-angle-double-right fa-fw me-1",
        subDrop: [
          {
            title: "Listado de Compromisos por Pagar",
            itemClickValue: 106,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Listado de Compromisos por Causar",
            itemClickValue: 107,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Resumen de Compromisos por Beneficiarios",
            itemClickValue: 108,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Listado General de Compromisos",
            itemClickValue: 109,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Listado de Compromisos por Proveedor",
            itemClickValue: 110,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Listado por Tipo de Compromiso",
            itemClickValue: 111,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Listado de Ordenes de Pagos x Cuentas",
            itemClickValue: 112,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Compromisos X.Ctas Presupuestarias",
            itemClickValue: 113,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },
      {
        title: "Rendición de Cuentas »",
        itemClickValue: null,
        icon: "fas fa-angle-double-right fa-fw me-1",
        subDrop: [
          {
            title: "Relación de Gastos por Orden de Pago",
            itemClickValue: 114,
            icon: "fas fa-poll-h fa-fw me-1",
          },
          {
            title: "Resumen de Proyectos",
            itemClickValue: 115,
            icon: "fas fa-poll-h fa-fw me-1",
          },
        ],
      },
    ],
  };
  const configuracionItem = {
    title: "configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "usuarios",
        itemClickValue: 20,
        icon: "fas fa-users-cog fa-fw me-1",
      },
      {
        title: "Cambiar Clave Supervisor Presupuesto",
        icon: "fa fa-user-tie me-2",
        itemClickValue: 117,
        permission: superpresu,
      },
    ],
  };
  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgPresupuesto}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };

  const vista = {
    /* 6: <ImpCedulaCatastral show={show} setShow={setShow} operacion={tipoRep} />,
        7: <ImpNoVivienda show={show} setShow={setShow} />, */
    0: <PorDefecto />,
    1: (
      <TablaEjFiscal
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    2: (
      <TablaCatgProgramaticas
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    3: (
      <TablaClasificadorPresupuestario
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    4: (
      <TablaPresupuesto
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    5: (
      <TablaCuadroObra
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    6: (
      <TablaPartidasExtras
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    7: (
      <TablaAumentados
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    8: (
      <TablaDisminucion
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    9: (
      <TablaTraslados
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    10: (
      <TablaCompromisos
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    11: (
      <TablaAjustarCompromisos
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    12: (
      <TablaCreditoAdicional
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    13: (
      <TablaAprobarCompromisos
        ubi={ubi}
        tipo={tipo}
        devueltov={devuelto}
        tipocom={tipocom}
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    14: (
      <TablaAprobarImputacion
        ubi={ubi}
        tipo={tipo}
        devueltov={devuelto}
        tipocom={tipocom}
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    15: (
      <TablaDesaprobarSolicitudCompras
        ubi={ubi}
        devueltov={devuelto}
        tipo={tipo}
        tipocom={tipocom}
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    17: (
      <TablaDesaprobarSolicitudObras
        ubi={ubi}
        devueltov={devuelto}
        tipo={tipo}
        tipocom={tipocom}
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    18: (
      <TablaDesaprobarSolicitudDonacion
        ubi={ubi}
        devueltov={devuelto}
        tipo={tipo}
        tipocom={tipocom}
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    16: (
      <TablaModificarCompromisos
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    20: (
      <TablaUsuarioPresu
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    23: <ImprimirDozavo show={show} onHideCancela={() => setShow(false)} />,

    24: (
      <ImprimirEstadoFinancieroPresupuesto
        show={show}
        onHideCancela={() => setShow(false)}
      />
    ),

    25: (
      <ImprimirEjecucionTrimestralIngresos
        show={show}
        onHideCancela={() => setShow(false)}
      />
    ),

    26: (
      <ImprimirEJCGR
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={titulo2}
      />
    ),

    27: (
      <ImprimirMIJMFBCV
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={titulo1}
      />
    ),

    28: (
      <ImprimirRelacionObrasProyectos
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={titulo3}
      />
    ),

    29: (
      <ImprimirDisponibilidadporPartidas
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
      />
    ),

    30: (
      <ImprimirEjecucionMensualPartidasdCuentas
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={titulo}
      />
    ),

    31: (
      <ImprimirEjGastoPartCuentSubCat
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
      />
    ),

    32: (
      <ImprimirEjGastoPartCuents
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={titulo4}
      />
    ),

    33: (
      <ImprimirPartidasSubCreaReduV
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={vtitulo}
      />
    ),

    34: (
      <ImprimirCompOrdServc
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={vtitulo1}
      />
    ),

    35: (
      <ImprimirTrasladoListaCompromisoProveedor
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={vtitulo2}
      />
    ),

    36: (
      <ImprimirListaXOrdenCompra
        show={show}
        onHideCancela={() => {
          (setShow(false), setTabla(0));
        }}
        condicion={vtitulo3}
      />
    ),
    37: <CambiarEfiscal show={show} onHideCancelar={() => setShow(false)} />,
    117: <CambiarClaveSupervisor supervisor="presu" show={show} setShow={setShow} setTabla={setTabla} login={login}/>,
  };
  useEffect(() => {
    SeleccionarEfiscal();
  }, []);

  useEffect(() => {
    if (tabla === 1) {
      if (accefiscal.toString() === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } 
    } else if (tabla === 20) {
      if (accusuariopresu.toString() === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } else if (tabla === 40) {
      console.log("entra");
      setActivate(true);
      setOperacion(1);
      SelecccionarEfiscal(idefiscal);
    } else if (tabla === 42) {
      setOperacionpu(2);
      SelecccionarEfiscals(idefiscal);
    } else if (tabla === 41) {
      let msg = "";
      setOperacioncat(6);
      setValorcp(31);
      if (statuspresup === 1) {
        msg =
          "Esta seguro de que desea eliminar las categorias programaticas?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else {
        msg =
          "Las categorias no pueden ser eliminadas porque el presupuesto esta aprobado o cerrado";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: msg,
          icono: "informacion",
        });
      }
    } else if (tabla === 43) {
      let msg = "";
      setOperacioncat(7);
      setValorcp(11);
      if (statuspresup === 1) {
        msg =
          "Esta seguro de que desea eliminar el Clasificador Presupuestario de cuentas?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else {
        msg =
          "El PUC no puede ser eliminado porque el presupuesto esta aprobado o cerrado";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: msg,
          icono: "informacion",
        });
      }
    } else if (tabla === 21) {
      let msg = "";
      setOperacioncat(8);
      setValorcp(1);
      if (statuspresup === 1) {
        msg = "Esta seguro de que desea eliminar el presupuesto?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else {
        msg =
          "El Presupuesto no puede ser eliminado porque el ya esta aprobado o cerrado";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: msg,
          icono: "informacion",
        });
      }
    } else if (tabla === 13) {
      setDevuelto(1);
      setUbi(40);
      setTipo(1);
      setTipocom(0);
    } else if (tabla === 14) {
      setDevuelto(1);
      setUbi(90);
      setTipo(1);
      setTipocom(7);
    } else if (tabla === 15) {
      let ubic;
      let tipoc;
      let tipocomc;

      if (espiritu === 8) {
        ubic = 59;
        tipoc = 0;
        tipocomc = 2;
      } else {
        ubic = 40;
        tipoc = 0;
        tipocomc = 2;
      }
      setDevuelto(1);
      setUbi(ubic);
      setTipo(tipoc);
      setTipocom(tipocomc);
    } else if (tabla === 44) {
      //setTabla(16);
      setMostrarUsuario(true);
    } else if (tabla === 17) {
      setDevuelto(0);
      setUbi(40);
      setTipo(0);
      setTipocom(3);
    } else if (tabla === 18) {
      setDevuelto(0);
      setUbi(95);
      setTipo(0);
      setTipocom(7);
    } else if (tabla === 45) {
      if (accreppuc.toString() === "1") {
        var reporte = "PUCGEN";
        window.open(
          op.reportes +
            "/contabilidadpresupuestaria?" +
            "reporte=" +
            reporte +
            "&sql1=" +
            idefiscal,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      }
      setTabla(0);
    } else if (tabla === 46) {
      var reporte = espiritu === 2 ? "Pres_IngrOrd" : "Pres_Ingr";
      console.log(espiritu);

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 47 || tabla === 69) {
      var reporte;
      if (espiritu === 8) {
        reporte = "Categoria_Programatica_Gob";
      } else {
        if (espiritu === 10) {
          reporte = "Categoria_ProgramaticaCabF2103";
        } else {
          reporte = "Categoria_ProgramaticaF2103";
        }
      }
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 48) {
      var reporte = "Pres_ObjGtos";
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 49 || tabla === 50) {
      var reporte;
      var ope = tabla === 49 ? 1 : tabla === 50 ? 2 : 0;
      if (espiritu === 10) {
        if (ope === 1) {
          reporte = "Pres_FormulacionCab";
        } else {
          reporte = "Pres_FormulacionOrdinalCab";
        }
      } else {
        if (ope === 1) {
          reporte = "Pres_Formulacion";
        } else {
          reporte = "Pres_FormulacionOrdinal";
        }
      }
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (
      tabla === 51 ||
      tabla === 52 ||
      tabla === 53 ||
      tabla === 54 ||
      tabla === 55
    ) {
      var reporte = "Pres_CAT_RGastos";
      var parametro;
      if (tabla === 51) {
        parametro = 1;
      } else if (tabla === 52) {
        parametro = 2;
      } else if (tabla === 53) {
        parametro = 3;
      } else if (tabla === 54) {
        parametro = 4;
      } else if (tabla === 55) {
        parametro = 5;
      }
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          parametro,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 56) {
      var reporte = "Pres_CuadroObras";
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 57) {
      var reporte = "Pres_CargosxDpto";
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 58) {
      var reporte = "Tipo_Cargo";
      var anio = efiscalanio;
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&anio=" +
          anio,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 59) {
      var reporte = "Pres_Transferencias";
      var parametro = "SUBSTRING(PUC,1,3)='407'";
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          parametro,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 60) {
      var reporte = "Pres_Inversiones";
      var parametro = "SUBSTRING(cta_codigo,1,3)='404'";
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          parametro,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 61) {
      var reporte = "Pres_Adquisiciones";
      var parametro = true;
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          parametro,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 62) {
      var reporte = "Pres_FormulacionResumen";
      var parametro = true;
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          parametro,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 63) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_Informacion_MunicipioCabF2100";
      } else {
        reporte = "Pres_Informacion_MunicipioF2100";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          idorganizacion,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );

      setTabla(0);
    } else if (tabla === 64) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_Recurso_Humano_Cargo_GeneroCabF2107";
      } else {
        reporte = "Pres_Recurso_Humano_Cargo_GeneroF2107";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          idorganizacion,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );

      setTabla(0);
    } else if (tabla === 65) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_Descripcion_ProgramaCabF2111";
      } else {
        reporte = "Pres_Descripcion_ProgramaF2111";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          idorganizacion,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 66) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_Metas_ProgramaCabF2112";
      } else {
        reporte = "Pres_Metas_ProgramaF2112";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          idorganizacion,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 67) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_Jubilado_PensionadoCabF2114";
      } else {
        reporte = "Pres_Jubilado_PensionadoF2114";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          idorganizacion,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 68) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_IngrCabF2102";
      } else {
        reporte = "Pres_IngrF2102";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal +
          "&sql2=" +
          idorganizacion,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );

      setTabla(0);
    } else if (tabla === 70) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_Sector_ResumenCab2106";
      } else {
        reporte = "Pres_Sector_Resumen2106";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 71) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_Sector_PartidasCabF2119";
      } else {
        reporte = "Pres_Sector_PartidasF2119";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 72) {
      var reporte;

      if (espiritu === 10) {
        reporte = "Pres_FormulacionOrdinalPartidaCab";
      } else {
        reporte = "Pres_FormulacionOrdinalPartida";
      }

      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 73) {
      setTitulo2("EJ_DPP01");
      setTabla(26);
    } else if (tabla === 74) {
      setTitulo2("EJ_DPP02");
      setTabla(26);
    } else if (tabla === 75) {
      setTitulo2("EJ_DPP03");
      setTabla(26);
    } else if (tabla === 76) {
      setTitulo2("EJ_DPP04");
      setTabla(26);
    } else if (tabla === 77) {
      setTitulo2("EJ_DPP05");
      setTabla(26);
    } else if (tabla === 78) {
      setTitulo2("EJ_DPP06");
      setTabla(26);
    } else if (tabla === 79) {
      setTabla(27);
      setTitulo1("MIJ_01");
    } else if (tabla === 80) {
      setTabla(27);
      setTitulo1("MIJ_02");
    } else if (tabla === 81) {
      setTabla(27);
      setTitulo1("MF_00");
    } else if (tabla === 82) {
      setTabla(27);
      setTitulo1("BCV_F3");
    } else if (tabla === 83) {
      setTabla(27);
      setTitulo1("BCV_F6");
    } else if (tabla === 84) {
      setTitulo2("CGR_01");
      setTabla(26);
    } else if (tabla === 85) {
      setTitulo2("CGR_02");
      setTabla(26);
    } else if (tabla === 86) {
      var reporte = "Pres_CAT5_EdoEjecGasto";
      window.open(
        op.reportes +
          "/contabilidadpresupuestaria?" +
          "reporte=" +
          reporte +
          "&sql1=" +
          idefiscal,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setTabla(0);
    } else if (tabla === 87) {
      setTabla(28);
      setTitulo3("Relacion de Obras");
    } else if (tabla === 88) {
      setTabla(28);
      setTitulo3("Resumen General de Proyectos");
    } else if (tabla === 89) {
      setTitulo("Nivel Partidas de Cuentas");
      setTabla(30);
    } else if (tabla === 90) {
      setTitulo("Sectores");
      setTabla(30);
    } else if (tabla === 91) {
      setTitulo("Programas");
      setTabla(30);
    } else if (tabla === 92) {
      setTitulo("Sub-Programas");
      setTabla(30);
    } else if (tabla === 93) {
      setTitulo("Proyectos");
      setTabla(30);
    } else if (tabla === 94) {
      setTitulo("Actividad");
      setTabla(30);
    } else if (tabla === 95) {
      setTitulo("Disponibilidad del Periodo General");
      setTabla(30);
    } else if (tabla === 96) {
      setTitulo4("Analitico por Partidas");
      setTabla(32);
    } else if (tabla === 97) {
      setTitulo4("Ejecución del Gasto por Partidas");
      setTabla(32);
    } else if (tabla === 98) {
      setTitulo4("Ejecución del Gasto por Cuentas");
      setTabla(32);
    } else if (tabla === 99) {
      setVtitulo("Aumento y/o Crédito Adicional");
      console.log("Aumento y/o Crédito Adicional");

      setTabla(33);
    } else if (tabla === 100) {
      setVtitulo("Reducción");
      console.log("Reducción");
      setTabla(33);
    } else if (tabla === 101) {
      setVtitulo2("Traslado");
      setTabla(35);
    } else if (tabla === 102) {
      setVtitulo("Nivel de Partidas");
      console.log("Nivel de Partidas");

      setTabla(33);
    } else if (tabla === 103) {
      setVtitulo("Nivel de SubEspecificas");
      console.log("Nivel de SubEspecificas");

      setTabla(33);
    } else if (tabla === 104) {
      setVtitulo("Nivel de SubEspecificas por Sector");
      console.log("Nivel de SubEspecificas por Sector");

      setTabla(33);
    } else if (tabla === 105) {
      setVtitulo("Partidas Creadas a Posteriori");
      console.log("Partidas Creadas a Posteriori");

      setTabla(33);
    } else if (tabla === 106) {
      setVtitulo1("Listado de Compromisos por Pagar");
      setTabla(34);
    } else if (tabla === 107) {
      setVtitulo1("Listado de Compromisos por Causar");
      setTabla(34);
    } else if (tabla === 108) {
      setVtitulo1("Resumen de Compromisos por Beneficiarios");
      setTabla(34);
    } else if (tabla === 109) {
      setVtitulo1("Listado General de Compromisos");
      setTabla(34);
    } else if (tabla === 110) {
      setVtitulo2("Listado de Compromisos por Proveedor");
      setTabla(35);
    } else if (tabla === 111) {
      setVtitulo1("Listado por Tipo de Compromiso");
      setTabla(34);
    } else if (tabla === 112) {
      setVtitulo3("Listado de Ordenes de Pagos x Cuentas");
      setTabla(36);
    } else if (tabla === 113) {
      setVtitulo3("Compromisos X.Ctas Presupuestarias");
      setTabla(36);
    } else if (tabla === 114 || tabla === 115) {
      console.log("114 || 115");
      if (tabla === 114) {
        setVtitulo("Relación de Gastos por Orden de Pago");
      } else {
        setVtitulo("Resumen de Proyectos");
      }
      setTabla(33);
    } else if (tabla === 116) {
      setTitulo3("Resumen General de Obras");
      setTabla(28);
    }
    /*     setTabla(0) */
  }, [tabla]);

  console.log(tabla);
  const menu = user ? (
    <div>
      <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
        <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
        <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
        <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />

        <a
          href="/inicio"
          className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
        >
          <i className="fas fa-power-off me-2" />
          Salir
        </a>
      </Menu>
      <section
        className="col-12 m-0 p-0 d-flex align-items-center justify-content-center"
        style={{ height: "90dvh" }}
      >
        {vista[tabla]}
      </section>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
          setTabla(0);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={2}
      />

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <CargarCatdesdeEfiscal
        show={mostrar3}
        operacion={operacion}
        onHideCancela={modalCargCat}
      />
      <CargarPucEfiscal
        show={mostrar4}
        operacion={operacionpu}
        onHideCancela={modalCargPuc}
      />
      <Dimmer active={activate} inverted></Dimmer>

    </div>
  ) : (
    ""
  );

  return menu;
}
export default MenuPresupuesto;
